import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AffiliateBannerRoutingModule } from './affiliate-banner-routing.module';
import { AffiliateBannerComponent } from './affiliate-banner.component';
import { AffiliateLinkCopyModule } from '../affiliate-link-copy/affiliate-link-copy.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AffiliateBannerComponent],
  exports: [AffiliateBannerComponent],
  imports: [
    CommonModule,
    AffiliateBannerRoutingModule,
    AffiliateLinkCopyModule,
    MatIconModule,
  ],
})
export class AffiliateBannerModule {}
